import Phaser, {
    Display
} from 'phaser'

let aText
//let guide;
let gameScale;
let parent;
let sounds;
let rect;
let holder;
let text;
let space;

export default class QuizAnswer extends Phaser.GameObjects.GameObject {

    constructor(data) {
        //Phaser gameobjects require a scene and type
        super(data.scene, 'sprite');
        //hold the quiz question scene
        parent = data.scene;
        //The text for this answer
        aText = data.text;

        holder = data.holder || parent;
        this.holder = holder;
        //Is this the right answer?
        this.correct = data.correct;
        this.init();
    }

    init() {
        //Hold scenes to be used later
        //guide = parent.scene.get('guide');
        sounds = parent.scene.get('sounds');

        gameScale = parent.registry.get('scaleIt');
        this.gameScale = gameScale;
        this.maxWidth = 280 * gameScale;
        this.createText();

    }


    //Each answer is a button
    createText() {
        //add a container to the guide scene for all graphics
        this.btn = holder.add.container(0, 0);

        //add the text
        text = holder.add.text(0, 0, aText, {
            fontFamily: 'Maori, sans-serif',
            fontSize: 18 * gameScale,
            align: 'left',
            color: '#ffffff',
            wordWrap: {
                width: this.maxWidth,
                useAdvancedWrap: true
            },
        });
        text.setOrigin(0, 0.5);

        this.text = text;
        this.createRect();

    }

    createRect() {
        //Add a checkbox
        let rectWidth = 18 * gameScale;

        rect = holder.add.rectangle(rectWidth, text.y - text.height / 2 + rectWidth / 2 + 2 * gameScale, rectWidth, rectWidth, 0xffffff).setOrigin(0.5).setAlpha(0.9);
        rect.setStrokeStyle(2 * gameScale, 0x8d8b61);
        space = rect.width / 3;
        text.x = rect.x + rect.width / 2 + space;
        this.rect = rect;
        this.space = space;
        this.createIcon();

    }

    createIcon() {
        //add icon 
        rect = this.rect;
        let id;
        id = 'cross';
        if (this.correct == 'true') id = 'check';
        this.icon = holder.add.image(rect.x, rect.y, id);
        this.icon.setOrigin(0.5);
        this.icon.visible = false;
        this.createButton();
    }

    createButton() {

        //Hold graphics in the button container
        this.btn.add([rect, text, this.icon]);
        //The button needs a size to be interactive
        this.btn.setSize(text.width + rect.width + this.space, text.height);

        //The guide needs to know the width and height
        this.btn.setData({
            width: text.width + rect.width + this.space,
            height: text.height
        });

        //Hide the button until holder is ready to display it
        this.btn.visible = false;

        //setup events
        this.activateButton();
    }

    activateButton() {
        //make it interactive with a hit area

        this.btn.setInteractive({
            useHandCursor: true,
            hitArea: new Phaser.Geom.Rectangle(this.btn.width / 2 + this.rect.width, 0, this.btn.width, this.btn.height),
            hitAreaCallback: Phaser.Geom.Rectangle.Contains

        });
        //holder.input.enableDebug(this.btn, 0xffcc00);
        //this.btn.on('pointerdown', sounds.playClick);
        this.btn.on('pointerover', this.onOffbtn);
        this.btn.on('pointerout', this.onOffbtn);
        this.btn.on('pointerup', this.checkAnswer, this);
    }

    checkAnswer() {
        this.icon.visible = true;
        let val = 'wrong';
        if (this.correct == 'true') {
            val = 'right';
            // parent.incScore();
        }

        sounds.blipBloop(val);
        parent.answerGiven(this.correct);
    }

    onOffbtn() {

        if (this.scale == 1) {
            this.setScale(1.1);
        } else {
            this.setScale(1);
        }
    }

    getButton() {
        return (this.btn);
    }

    destroyIt() {
        this.btn.removeAll(true);
        this.btn.removeAllListeners();
        this.btn.disableInteractive();
        this.btn.destroy();

        this.removeInteractive();
        this.setActive(false);
        //this.destroy();
    }



}